// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/product/product-detail/product-detail.scss
// module id = 509
// module chunks = 0